import * as Sentry from "@sentry/nextjs"

import { useUpdateCustomerInOrderMutation } from "@mono/essentials/entities/order/hooks"
import {
  CustomerTypeOrder,
  GetOrderDetailsResponseType,
  OrderCustomerType,
} from "@mono/essentials/types/OrderTypes"

export const useHandleUpdateCustomerInOrder = () => {
  const { mutateAsync: updateCustomerInOrderMutation } = useUpdateCustomerInOrderMutation()

  const handleUpdateCustomerInOrder = async ({
    customer,
    onError,
    onSuccess,
    orderData,
  }: {
    customer: OrderCustomerType | CustomerTypeOrder
    orderData: GetOrderDetailsResponseType
    onSuccess?: () => Promise<void>
    onError?: (error: any) => Promise<void>
  }) => {
    try {
      if (customer?.id && orderData?.id) {
        await updateCustomerInOrderMutation({
          orderId: orderData.id,
          body: {
            customer_id: customer.id,
          },
        })
        await onSuccess?.()
      }
    } catch (error) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleUpdateCustomerInOrder }
}
